import { useState, useEffect, useCallback } from 'react';
import { fetchUserEnquiries, ServiceApplication } from '../utils/user';
import useTokenStore from '../store/store';

export const useUserEnquiries = () => {
  const [enquiries, setEnquiries] = useState<ServiceApplication[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const getToken = useTokenStore((state) => state.token);

  const fetchEnquiries = useCallback(async () => {
    if (!getToken) {
      setEnquiries([]);
      return;
    }

    setLoading(true);
    setError(null);
    
    try {
      const data = await fetchUserEnquiries(getToken);
      setEnquiries(data);
    } catch (err) {
      console.error('Error fetching enquiries:', err);
      setError('Failed to fetch service applications');
    } finally {
      setLoading(false);
    }
  }, [getToken]);

  useEffect(() => {
    fetchEnquiries();
  }, [fetchEnquiries]);

  return {
    enquiries,
    loading,
    error,
    refetch: fetchEnquiries
  };
}; 